import React from 'react';
const TermsCondition = () => {
    return (
        <div className="container mx-auto p-6">
            <h1 className="text-3xl font-bold mb-4">Terms and Conditions of Roomease</h1>
            <p className="mb-4">Effective Date: January 15, 2025</p>
            <p className="mb-4">
                Welcome to Roomease! These Terms and Conditions (“Terms”) govern your access to and use of our mobile application (“App”) and services. By downloading, installing, or using Roomease, you agree to be bound by these Terms. If you do not agree, please refrain from using the App.
            </p>

            <h2 className="text-2xl font-semibold mt-6 mb-2"> Eligibility</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>You must be at least 18 years old to use Roomease.</li>
                <li>  You agree to provide accurate and complete information during registration.</li>
                <li>    False or Incomplete Information: Providing false or incomplete registration information may result in account suspension or termination.</li>
            </ul>
            <p>By using Roomease, you consent to the collection, storage, and use of your personal data as described herein.</p>

            <h2 className="text-2xl font-semibold mt-6 mb-2"> User Accounts</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Account Responsibility: You are responsible for maintaining the confidentiality of your login credentials.</li>
                <li>Account Sharing: Sharing your account with others is prohibited.</li>
                <li>Account Suspension: Roomease reserves the right to suspend or terminate accounts found violating these Terms.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2"> User Data and Privacy
            </h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Roomease collects limited personal data, including phone numbers, email addresses, gender, and location, strictly for matchmaking purposes.</li>
                <li>Data Retention: Data will be retained for 5 years unless requested for deletion. Data may also be deleted automatically in cases of prolonged inactivity or account closure.</li>
                <li>Roomease complies with applicable data protection laws, including the IT Act, 2000 and, where applicable, the General Data Protection Regulation (GDPR). User data will be processed lawfully and transparently.</li>
                <li>Refer to our [Privacy Policy](insert link) for detailed information on data handling.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Matchmaking Services
            </h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Roomease uses algorithms to match users based on preferences, compatibility, and shared interests.</li>
                <li>Matches are suggestions only, and Roomease does not guarantee the success of any roommate arrangements.
                </li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Prohibited Activities</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Use the App for illegal or unauthorized purposes.</li>
                <li>Misrepresent your identity or provide false information.</li>
                <li>Upload inappropriate content, including but not limited to: </li>
                <li>  Hate speech or discriminatory remarks.</li>
                <li>    Sexual, obscene, or offensive content.</li>
                <li>    False or misleading information.</li>
                <li>Harass, abuse, or harm other users.</li>
                <li>Reverse-engineer, modify, or tamper with the App.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Community Guidelines</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Treat all users with respect and avoid hate speech, harassment, or discrimination.</li>
                <li>Users violating community guidelines may face account suspension or legal action.</li>
                <li>Roomease reserves the right to investigate and take legal action against violators.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Reporting and Blocking
            </h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Users can report profiles engaging in inappropriate behavior or violating community guidelines.</li>
                <li>To report a user, use the in-app “Report” button and provide details of the incident.</li>
                <li>RUsers also have the option to block profiles they find uncomfortable or inappropriate.</li>
                <li>Reported accounts will be reviewed, and Roomease may suspend or terminate the account if violations are confirmed.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Safety Recommendations</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Always meet potential roommates in public spaces.</li>
                <li>Inform friends or family members about your meeting details.</li>
                <li>Avoid sharing sensitive personal information prematurely.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">Emergency Clause</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>  Roomease is not liable for users’ personal safety during in-person meetings or roommate arrangements.</li>
                <li>In case of emergencies, users should contact local authorities or emergency services immediately.</li>
                <li>Roomease strongly advises users to conduct thorough background checks and communicate responsibly before meeting anyone in person.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Third-Party Services</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>  Roomease integrates third-party services such as Firebase and Google APIs to enhance functionality, including location-based matchmaking.</li>
                <li>By using the App, you agree to the terms and policies of these third-party services.</li>
                <li>Roomease is not responsible for the performance or functionality of third-party services.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Subscription and Payment Terms
            </h2>
            <ul className="list-disc ml-6 mb-4">
                <li>  If Roomease introduces premium features, payment details and pricing will be disclosed.</li>
                <li>Refunds, if applicable, will be processed within 7 business days in compliance with our refund policy.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Beta Testing Disclaimer
            </h2>
            <ul className="list-disc ml-6 mb-4">
                <li>  Roomease may introduce features under beta testing, allowing users to voluntarily opt in.</li>
                <li>Beta features may have bugs, limitations, or interruptions.</li>
                <li>  Users opting into beta testing agree to provide feedback to improve the features but are not obligated to do so.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Updates to Features and Services</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>  Roomease reserves the right to modify, update, or discontinue any feature, service, or aspect of the App at any time without prior notice.</li>
                <li>Users will be notified about significant updates through in-app notifications or emails.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2"> Termination by Roomease</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>  Roomease reserves the right to terminate user accounts under the following circumstances:</li>
                <li>Violations of these Terms or Community Guidelines.</li>
                <li>Fraudulent or harmful behavior.</li>
                <li>Prolonged inactivity of over 12 months.</li>
                <li>Users will be notified of termination via email or in-app notification.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Data Retention and Deletion</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>User data will be retained for 5 years post-account deactivation unless explicitly requested for deletion.</li>
                <li>Users may contact our Grievance Officer to request deletion.</li>
            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2"> Disclaimer of Warranties</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Roomease makes no warranty regarding the availability, reliability, or security of its services.</li>
                <li>   The App is provided “as-is” and “as-available” without warranties of any kind, including implied warranties of merchantability, fitness for a particular purpose, or non-infringement.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Limitation of Liability</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Roomease is not responsible for any indirect, incidental, or consequential damages arising from your use of the App.</li>
                <li>   By using Roomease, you agree to waive any claims for such damages.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Dispute Resolution</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Roomease is not a party to disputes between users.</li>
                <li>Users are encouraged to resolve conflicts amicably or through mediation.</li>
                <li>Roomease is not responsible for any loss or damage arising from such disputes.</li>
            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2">Grievance Redressal Mechanism</h2>
            <li>If you have complaints or concerns, contact our Grievance Officer:</li>
            <li><strong>Email:</strong> support@roomease.co.in</li>
            <li><strong>Phone:</strong> 9569994536</li>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Severability Clause</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>If any provision of these Terms is found to be unenforceable, the remaining provisions will remain in full force and effect.</li>

            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Force Majeure Clause</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Roomease is not liable for delays or failures caused by events beyond its reasonable control, including but not limited to natural disasters, government actions, or technical failures.</li>

            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2"> Governing Law and Jurisdiction</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>These Terms shall be governed by and construed in accordance with the laws of India.</li>
                <li>Any disputes will be subject to the exclusive jurisdiction of courts in Delhi.
                    Terms & Conditions Updates</li>

            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2">A. Accuracy of Information Clause</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>       By signing up on Roomease, you agree to provide accurate and truthful information, including your Instagram username if requested. Roomease does not verify whether the provided Instagram account is real, active, or belongs to you.</li>

            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2">B. Data Collection Clause</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>We collect Instagram usernames to gather additional user data and improve profile authenticity. However, Roomease does not guarantee the validity of any Instagram account provided and does not conduct automated verification.</li>

            </ul>
            <h2 className="text-2xl font-semibold mt-6 mb-2">C. User Responsibility Clause</h2>
            <ul className="list-disc ml-6 mb-4">
                <li>Users acknowledge that providing an Instagram username does not confirm verification or authenticity. Roomease is not responsible for any false or misleading Instagram details provided by users.</li>

            </ul>

            <h2 className="text-2xl font-semibold mt-6 mb-2">Acknowledgment</h2>
            <p>By using Roomease, you confirm that you have read, understood, and agree to these Terms and Conditions</p>

        </div>
    );
};
export default TermsCondition;